module.exports = __webpack_public_path__ + "static/img/fws_bg_settled in.b9cf3e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/fws_bg_settled in.png
// module id = BuXA
// module chunks = 1